import { INursery } from 'v2/resources/types/nurseries';
export interface IStateNurseries {
  nurseries: INursery[];
}
export const initialState: IStateNurseries = {
  nurseries: [],
};
